module.exports = __webpack_public_path__ + "img/transparency.a071f956.svg";